export default "__VITE_ASSET__BUUTlNnT__"